import { adminHttpClient } from '../../../commons/adminHttpClient'

const removeIncompleteProductClass = (productClassId: string): Promise<{ productClassId: string }> => {
    return adminHttpClient.post(`/Benefit/BenefitRenewal/Ichra/RemoveIncompleteProductClass`, { productClassId })
  }
  
  export default removeIncompleteProductClass